import { FormInstance } from 'antd';
import axios from 'axios';
import { BASE_URL, CONTENT_API_PATH } from 'constants/api';
import { ApiService } from 'service/api/apiService';
import { FetchResult } from 'type/apiType';
import { EpisodeInterface } from '../types/episodeType';

class EpisodeService {
  constructor(private apiService: ApiService<EpisodeInterface>) {}

  async fetch(query: URLSearchParams): Promise<FetchResult<EpisodeInterface>> {
    return await this.apiService.fetch(query);
  }

  async fetchById(id: number): Promise<EpisodeInterface> {
    return await this.apiService.fetchById(id);
  }

  async create(
    form: FormInstance,
    customData?: Partial<EpisodeInterface>
  ): Promise<EpisodeInterface> {
    // customData가 있으면 customData만 사용, 없으면 form 데이터 사용
    const mergedData = customData || form.getFieldsValue();

    // Ensure i18n fields are included
    if (!mergedData.i18n_title) mergedData.i18n_title = {};
    if (!mergedData.i18n_secondary_title) mergedData.i18n_secondary_title = {};
    if (!mergedData.i18n_seo_title) mergedData.i18n_seo_title = {};
    if (!mergedData.i18n_seo_keyword) mergedData.i18n_seo_keyword = {};
    if (!mergedData.i18n_seo_synopsis) mergedData.i18n_seo_synopsis = {};

    const response = await this.apiService.create(mergedData);
    return response;
  }

  async update(
    id: number,
    form: FormInstance,
    customData?: Partial<EpisodeInterface>
  ): Promise<EpisodeInterface> {
    // customData가 있으면 customData만 사용, 없으면 form 데이터 사용
    const mergedData = customData || form.getFieldsValue();

    const response = await this.apiService.update(id, mergedData);
    return response;
  }

  async delete(id: number): Promise<void> {
    await this.apiService.delete(id);
  }

  async batchUpdateOrder(updates: { content_id: number; episode_order: number }[]): Promise<void> {
    const response = await axios.patch(`${BASE_URL}${CONTENT_API_PATH}episode-order/`, {
      updates,
    });
    return response.data;
  }
}

export const episodeService = new EpisodeService(
  new ApiService<EpisodeInterface>(CONTENT_API_PATH)
);
